// extracted by mini-css-extract-plugin
export var active = "_1w-9";
export var backButton = "_1w-8";
export var clone = "_1w-e";
export var collapseBar = "_1w-k";
export var collapseMode = "_1w-m";
export var collapsed = "_1w-o";
export var dimmed = "_1w-i";
export var dragHandle = "_1w-c";
export var dropdownIcon = "_1w-g";
export var expanding = "_1w-n";
export var hidden = "_1w-x";
export var iconContainer = "_1w-q";
export var iconSwapper = "_1w-w";
export var navItem = "_1w-6";
export var navItemIcon = "_1w-f";
export var navProfile = "_1w-7";
export var notificationCountBadge = "_1w-j";
export var notificationDot = "_1w-r";
export var optionsContainer = "_1w-h";
export var primaryNav = "_1w-0";
export var primaryNavDivider = "_1w-v";
export var primaryNavResizeHandle = "_1w-2";
export var primaryNavResizing = "_1w-1";
export var primaryNavTabSection = "_1w-u";
export var primaryTab = "_1w-p";
export var primaryTabIconBox = "_1w-s";
export var secondaryNav = "_1w-3";
export var selected = "_1w-t";
export var settingsNav = "_1w-4";
export var settingsNavItems = "_1w-5";
export var show = "_1w-d";
export var sideNav = "_1w-l";
export var teamItem = "_1w-a";
export var userProfileItem = "_1w-b";